import { Cell } from "./cell.mjs";

/**
 * DataTable2. Data is added at once through the constructor. 
 * Can be provided by row or column 
 * Data store as row 
 * TODO: log 
 */


export class DataTable{
    constructor(tableOptions){
        if (!tableOptions || !tableOptions.data || !tableOptions.dataType) throw new Error('table Options are mandatory ');
        var _dataTable = [];

        Object.defineProperty(this,'data',{ 
            get : ()=>_dataTable
        });

        Object.defineProperty(this,'addRow',{
            value: (row)=>{ _dataTable.push(row) }
        })




        this.initDataTable(tableOptions);
    }
    // ==========
    // private
    // ----------
    getData(){ return this.data }

    initDataTable(tableOptions){
        var data = tableOptions.data; 
        var ignoreMerge = tableOptions.ignoreMerge;
        if (tableOptions.dataType === 'column'){ 
            data = DataTable.transpose(data);
        }
        data = data.map(row =>new Row(row, ignoreMerge)); 
        data.forEach(this.addRow);
    }

    // ==========
    // public
    // ----------
    getRowIterator(){
        return this.getData()[Symbol.iterator]();
    }

    getRows(){ return this.getData() }



    // ==========
    // static 
    // ----------
    static transpose(a) {
        var w = a.length || 0;
        var h = a[0] instanceof Array ? a[0].length : 0;
        if(h === 0 || w === 0) { return []; }
    
        var i, j, t = [];
        for(i=0; i<h; i++) {
          t[i] = [];
          for(j=0; j<w; j++) {
            t[i][j] = a[j][i];
          }
        }
        return t;
      }
}


export class Row{
    constructor(array, ignoreMerge = false){
        this.data = array.map(this.createCell); 
        this.ignoreMerge = ignoreMerge;
    }
    //==========
    // private 
    // ----------
    createCell(data){
        var cell;
        if (typeof data ==='string') {
            cell = new Cell();
            cell.addContent(data);
        }
        if (data instanceof Cell){ 
            cell = data;
        }
        return cell;
    }


    // =========
    // private
    // ---------
    getData(){ return this.data }

    getIgnoreMerge(){ return this.ignoreMerge }

    reduceRow(){
        var row = this.getData();
        var newRow = [];
        var group = []; // previousGroup
        var last = false; 
        var cell;

        for (var i = 0; i < row.length; i++){
            cell = row[i];
            last = (i == (row.length -1));
            var merge = cell.getMerge();

            if (merge) group.push(cell);
            if (!merge || last) {
                if (group.length > 1) group = [ this.merge(group) ]
                if (group.length === 1) newRow = newRow.concat(group);
                if (last && merge) return newRow;
                group = [cell];
                if (last) newRow = newRow.concat(group); 
            } 
        }

        return newRow;
    }

    merge(mergeCells){
        var cell = mergeCells[0];
        cell.setSpan(mergeCells.length)
        return mergeCells[0];
    }

    // =========
    // public
    // ---------

    getCells(){
        var ignoreMerge = this.getIgnoreMerge();
        var row; 
        if (!ignoreMerge) row = this.reduceRow();
        else row = this.getData();
        return row;
    }


}



/**
 * data : array of array of strings || array of array of cells 
 * dataType: 'rows' || 'columns' 
 * header : array of strings || array of cells 
 * ignoreMerge : boolean 
 */
 class TableOptions{}